export class DamageType {
    id: number = 0;
    name: string = '';
    active: boolean = false;
    inUse: boolean = false;

    // internal use only
    editing?: boolean;
}

export class DamageTypeUpdateDTO {
    id: number = 0;
    name: string = '';
    active: boolean = false;

    constructor(id: number, name: string, active: boolean) {
        this.id = id;
        this.name = name;
        this.active = active;
    }

    static fromDamageType({ id, name, active }: DamageType): DamageTypeUpdateDTO {
        return new DamageTypeUpdateDTO(id, name, active);
    }
}